const BuyPoIcon = (props: any) => {
    return <img {...props} alt="buy_po.png" src={require('./buy_po.png')} />;
};

export default BuyPoIcon;
